var _require = require('./sitelinks_helpers'),
    getSitelinkUrl = _require.getSitelinkUrl;

module.exports = function (sitelinks) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var addUrl = options.addUrl;
  return Object.keys(sitelinks).reduce(aggregateValues(sitelinks, addUrl), {});
};

var aggregateValues = function aggregateValues(sitelinks, addUrl) {
  return function (index, key) {
    var title = sitelinks[key].title;

    if (addUrl) {
      index[key] = {
        title: title,
        url: getSitelinkUrl(key, title)
      };
    } else {
      index[key] = title;
    }

    return index;
  };
};